module.exports = __webpack_public_path__ + "img/guide_m_vi.25da45f.webp";